<template>
    <div
        class="flex h-7 w-7 cursor-pointer items-center justify-center rounded-xl text-xs text-stone-600 hover:bg-primary-200 dark:text-primary-50 dark:hover:bg-dark-400"
    >
        <slot />
    </div>
</template>
